// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAnalyticsDashboardAppGroupIdEmailEngagementByTimeDataResult = arrayOf(
  objectOf({
    click_count: string,
    open_count: string,
    day: string,
  })
);
